import styled from 'styled-components';
import t from 'common/i18n';
import SvgIcon from '../SvgIcon';

import './NoResults.scss';

const StyledIcon = styled(SvgIcon)`
  margin-bottom: 10px;
`;

const NoResults = (props) => {
  const { text, icon } = props;

  return (
    <div className="no-results-message flex flex-column align-items-center" data-test="no-results-message">
      {icon ? <StyledIcon path={icon} size={72} colorName="menu-icons" /> : null}
      {text || t('no_results')}
    </div>
  );
};

export default NoResults;
